import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Form } from "react-final-form";
import Hidden from "@material-ui/core/Hidden";
import { Routes } from "../../../constants/routes";
import FormLink from "../../../components/FormLink";
import Typography from "@material-ui/core/Typography";
import TextDivider from "../../../components/TextDivider";
import { registerAgentFormValidator } from "../utils/validators/registerForm";
import makeStyles from "@material-ui/core/styles/makeStyles";
import RegisterAgentForm from "./forms/RegisterAgentForm";
import { texts } from "../constants/texts";
import { useWizard } from "../../wizard/context";

const useStyles = makeStyles(() => ({
  footer: {
    marginTop: 40,
  },
}));

function RegisterAgentWidget() {
  const {
    actions: { register },
  } = useAuth();

  const classes = useStyles();

  const { openWizard } = useWizard();

  const openModal = () => {
    openWizard({
      steps: [
        {
          titleConfig: {
            titleText: "OOPS.",
          },
          content: texts.warningMessage,
        },
      ],
      submitButtonText: "Ok",
      cancelButtonText: null,
    });
  };

  function _submit(data) {
    const errors = registerAgentFormValidator(data, openModal);
    if (
      Object.keys(errors).length > 1 ||
      Object.keys(errors.agentProfile).length
    ) {
      return errors;
    }

    return register(data, 2);
  }

  return (
    <>
      <Form onSubmit={_submit} component={RegisterAgentForm} />

      <Hidden mdUp>
        <div className={classes.footer}>
          <TextDivider text={"OR"} />
          <Typography component="p" align="center">
            Already Registered?{" "}
            <FormLink to={`/${Routes.LOGIN}`}>Sign In</FormLink>
          </Typography>
        </div>
      </Hidden>
    </>
  );
}

export default React.memo(RegisterAgentWidget);
